import type { Difficulty } from "@hunch/core";

export interface HuessworkConfig {
  rounds: number;
  gapWidthPercent: Record<Difficulty, number>;
  hueDistance: { min: number; max: number };
  minMidToEndDeltaE: number;
}

async function getJson<T>(path: string): Promise<T> {
  const res = await fetch(path, { credentials: "omit" });
  if (!res.ok) {
    const body = (await res.json().catch(() => ({}))) as { error?: string };
    throw new Error(body.error ?? `Request failed (${res.status})`);
  }
  return (await res.json()) as T;
}

export function fetchHuessworkConfig(): Promise<HuessworkConfig> {
  return getJson("/api/public/huesswork/config");
}
